<template>
	<page>
		<module>
			<h1>工具箱</h1>
			<ul class="tool flex-wrap">
				<li v-for="(item, i) in toolList" v-lock="lock(item.menu_unique_key)" :key="i" class="flex-center" @click="clickHandle(item)">
					<div class="tool-icon flex-center" :style="{'background': toolConfig[item.menu_unique_key].color}"><i class="tf">{{toolConfig[item.menu_unique_key].icon}}</i></div>
					<div class="flex-grow">
						<p class="tool-name flex-start-center">{{item.menu_name}}<img v-if="lock(item.menu_unique_key)" src="@/assets/image/vip.png"></p>
						<p class="tool-describe">{{toolConfig[item.menu_unique_key].describe}}</p>
					</div>
				</li>
				<li class="flex-center" disabled>
					<div class="tool-icon flex-center" :style="{'background': 'linear-gradient(-30deg, #F40000, #FF9696)'}"><i class="tf">&#xe6aa;</i></div>
					<div class="flex-grow">
						<p class="tool-name flex-start-center">更多工具<c-state color="#000" tag style="font-size: 12px;">敬请期待</c-state></p>
						<p class="tool-describe">蜂鸟工单将陆续上线更多的实用工具，敬请期待！</p>
					</div>
				</li>
			</ul>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		name: 'g_tool',

		data() {
			return {
				toolConfig: {
					m_batch_upload: {
						icon: '\ue696',
						color: 'linear-gradient(-30deg, #29A76B, #72D5A6)',
						describe: '一款提升图纸与附件资料的整理效率的工具'
					},
					m_scan_view: {
						icon: '\ue776',
						color: 'linear-gradient(-30deg, #2B73E7, #7EB2FF)',
						describe: '扫码或输入编号，快速查看业务数据中的图纸与附件'
					}
				}
			}
		},
		
		computed: {
			...mapState(['toolList'])
		},

		methods: {
			clickHandle(item) {
				if (this.lock(item.menu_unique_key)) {
					this.freeEditionTips();
					return;
				}
				this.navigateTo({
					name: item.menu_unique_key
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	h1 {
		padding: 24px 35px 0;
		font-size: 20px;
	}

	.tool {
		gap: 22px;
		padding: 18px 34px;

		li {
			gap: 22px;
			box-sizing: border-box;
			width: 500px;
			height: 100px;
			border-radius: 6px;
			padding: 0 16px;
			background: #F8F8F8;
			cursor: pointer;

			&:not([disabled]):hover {
				outline: 1px solid var(--color-main);
			}
		}

		&-icon {
			width: 64px;
			height: 64px;
			border-radius: 8px;
			font-size: 40px;
			color: #fff;
		}

		&-name {
			gap: 10px;
			font-size: 18px;
			
			img {
				height: 18px;
			}
		}

		&-describe {
			margin-top: 15px;
			font-size: 13px;
			color: #999;
		}
	}
</style>